import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { gladstoneMOConfig } from "./data";

export default function GladstoneMOPage() {
  return <CityPageTemplate config={gladstoneMOConfig} />;
}